import { IAppointment } from './appointment.dto';
import { IConsultation } from './consultation.dto';
import { ICustomerUser } from './customer.dto';
import { IOrder } from './order.dto';
import { ISubscription } from './subscription.dto';

export class Note {
  _id: string;
  customer: string | ICustomerUser;
  consultation?: string | IConsultation;
  appointment?: string | IAppointment;
  order?: string | IOrder;
  createdBy: { id: string; fullName: string };
  content: string;
  consultType: string;
  createdAt?: Date;
  updatedAt?: Date;
  organization?: string;
  subscription?: string | ISubscription;
}

export class INote extends Note {}
